import React, { useCallback } from 'react'

import { Dropdown, Flex } from '@sketch/components'
import { useSortingSettings } from 'modules/shares/hooks/useSortSettings'

import { ArrowDownIcon, ArrowUpIcon } from './SortDropdown.styles'

interface DropdownItemProps {
  label: string
  selected: boolean
  sortOrder?: 'asc' | 'desc'
  onSelect: () => void
  setSortOrder: (order: 'asc' | 'desc') => void
}

const DropdownItem: React.FC<DropdownItemProps> = ({
  label,
  selected,
  sortOrder,
  onSelect,
  setSortOrder,
}) => {
  const handleClick = useCallback(() => {
    if (selected) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')
    } else {
      onSelect()
    }
  }, [onSelect, selected, setSortOrder, sortOrder])

  return (
    <Dropdown.Item className={selected ? 'active' : ''} onClick={handleClick}>
      <Flex justifyContent="space-between">
        <div>{label}</div>
        {selected && sortOrder === 'asc' && <ArrowDownIcon />}
        {selected && sortOrder === 'desc' && <ArrowUpIcon />}
      </Flex>
    </Dropdown.Item>
  )
}

export const SortDropdown = () => {
  const { sortBy, sortOrder, setSortBy, setSortOrder } = useSortingSettings()

  return (
    <>
      <Dropdown.Header>Sort By</Dropdown.Header>
      <DropdownItem
        label="Name"
        selected={sortBy === 'name'}
        onSelect={() => setSortBy('name')}
        setSortOrder={setSortOrder}
        sortOrder={sortOrder}
      />
      <DropdownItem
        label="Date created"
        selected={sortBy === 'created-at'}
        onSelect={() => setSortBy('created-at')}
        setSortOrder={setSortOrder}
        sortOrder={sortOrder}
      />
      <DropdownItem
        label="Last updated"
        selected={sortBy === 'last-modified'}
        onSelect={() => setSortBy('last-modified')}
        setSortOrder={setSortOrder}
        sortOrder={sortOrder}
      />
    </>
  )
}
